module.exports = __webpack_public_path__ + "static/images/bg1.b80b468.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reg/bg1.jpg
// module id = eD7S
// module chunks = 1